import React from 'react';

import './../styles/toggle-buttons.css'

import Grid from '@mui/material/Unstable_Grid2';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

import { CheckmarkIcon } from '../assets/icons/checkmark';
import { CancelIcon } from '../assets/icons/cancel';

const DEFAULT_BUTTONS = [
  {
    value: 'NO',
    label1: 'No Embroidery',
    label2: '+ $0.00',
    icon: <CancelIcon />
  },
  {
    value: 'YES',
    label1: 'Add Embroidery',
    label2: '+ $25.00',
    icon: <CheckmarkIcon />
  }
]

function ToggleButtons({
  value = 'NO',
  buttons = DEFAULT_BUTTONS,
  onChange = () => {}
}) {
  return (
    <section className="toggle-buttons-wrapper">
      <Grid container className="toggle-buttons-container">
        <ToggleButtonGroup
          orientation="vertical"
          value={value}
          exclusive
          fullWidth
          onChange={onChange}
          size="large"
        >
          {buttons?.map((button, index) =>
            <ToggleButton key={`button-${index}`} value={button.value} aria-label="module" className="toggle-button">
              <span className="toggle-button-icon">
                {button.icon}
              </span>
              <span className="toggle-button-label">{button.label1}</span>
              <span className="toggle-button-label">{button.label2}</span>
            </ToggleButton>
          )}
        </ToggleButtonGroup>
      </Grid>
    </section>
  )
}

export default ToggleButtons
